<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <!-- <b-card v-if="tieneAcceso === true"> -->
          <b-card>
          <div slot="header">
            <strong>Consulta de Póliza</strong>
          </div>
          <div>
             <b-row class="my-1">
              <b-col sm="1">
                <label for="input-small">Póliza</label>
              </b-col>
              <b-col sm="2">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text" 
                  disabled
                  v-model="datosFormulario.poliza">
                </b-form-input>
              </b-col>
               <b-col sm="2">
                <b-button size="sm" variant="primary" @click="modalPolizas = true"><i class="fa fa-search"></i> Buscar Póliza</b-button>
               </b-col>
              <b-col sm="2">
                <b-button size="sm" v-if="this.hasSiniestro" variant="primary" @click="modalSiniestros = true"><i class="fa fa-search"></i> Ver Siniestro</b-button>
               </b-col>
            </b-row>  
            <b-row class="my-1">
              <b-col sm="1">
                <label for="input-small">Producto</label>
              </b-col>
              <b-col sm="1">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text" 
                  disabled
                  v-model="datosFormulario.producto">
                </b-form-input>
              </b-col>
              <b-col sm="1">
                 <label for="input-small">Vigencia</label>
              </b-col>
              <b-col sm="2">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text" 
                  disabled
                  v-model="datosFormulario.vigdesde">
                </b-form-input>
              </b-col>
              <b-col sm="2">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text" 
                  disabled
                  v-model="datosFormulario.vighasta">
                </b-form-input>
              </b-col>
              <b-col sm="1">
                <label for="input-small">Cobertura</label>
              </b-col>
              <b-col sm="4">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text" 
                  disabled
                  v-model="datosFormulario.cobertura">
                </b-form-input>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="1">
                <label for="input-small">Afianzado</label>
              </b-col>
              <b-col sm="1">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text"
                  disabled
                  v-model="datosFormulario.cccodigo">
                </b-form-input>
              </b-col>
              <b-col sm="1">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text"
                  disabled
                  v-model="datosFormulario.ccrut">
                </b-form-input>
              </b-col>
              <b-col sm="2">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text" 
                  disabled
                  v-model="datosFormulario.ccnombre">
                </b-form-input>
              </b-col>
              <b-col sm="1">
                <label for="input-small">Asegurado</label>
              </b-col>
              <b-col sm="1">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text"
                  disabled
                  v-model="datosFormulario.codaseg">
                </b-form-input>
              </b-col>
              <b-col sm="1">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text"
                  disabled
                  v-model="datosFormulario.rutaseg">
                </b-form-input>
              </b-col>
              <b-col sm="2">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text" 
                  disabled
                  v-model="datosFormulario.nombreaseg">
                </b-form-input>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="1">
                <label for="input-small">Beneficiario</label>
              </b-col>
              <b-col sm="1">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text"
                  disabled
                  v-model="datosFormulario.codbenef">
                </b-form-input>
              </b-col>
              <b-col sm="1">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text"
                  disabled
                  v-model="datosFormulario.rutbenef">
                </b-form-input>
              </b-col>
              <b-col sm="2">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text" 
                  disabled
                  v-model="datosFormulario.nombrebenef">
                </b-form-input>
              </b-col>
              <b-col sm="1">
                <label for="input-small">Corredor</label>
              </b-col>
              <b-col sm="1">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text"
                  disabled
                  v-model="datosFormulario.codcorr">
                </b-form-input>
              </b-col>
              <b-col sm="1">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text"
                  disabled
                  v-model="datosFormulario.rutcorr">
                </b-form-input>
              </b-col>
              <b-col sm="2">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text" 
                  disabled
                  v-model="datosFormulario.nombrecorr">
                </b-form-input>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="1">
                <label for="input-small">Mto. Asegurado</label>
              </b-col>
              <b-col sm="1">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text"
                  disabled
                  v-model="datosFormulario.monedapol">
                </b-form-input>
              </b-col>
              <b-col sm="1">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text"
                  disabled
                  v-model="datosFormulario.mtoaseg">
                </b-form-input>
              </b-col>
              <b-col sm="1">
                <label for="input-small">Condicionado</label>
              </b-col>
              <b-col sm="2">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text"
                  disabled
                  v-model="datosFormulario.condicion">
                </b-form-input>
              </b-col>
              <b-col sm="1">
                <label for="input-small">Eje. Com.</label>
              </b-col>
              <b-col sm="1">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text" 
                  disabled
                  v-model="datosFormulario.ejecom">
                </b-form-input>
              </b-col>
              <b-col sm="1">
                 <label for="input-small">Asis. Com.</label>
              </b-col>
              <b-col sm="1">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text" 
                  disabled
                  v-model="datosFormulario.asiscom">
                </b-form-input>
              </b-col>
            </b-row>    
            <b-row  class="my-1" v-if="this.actboton_lrp">
              <b-col sm="4">
                <label for="input-small">Póliza:</label>
              </b-col>
              <b-col sm="2">
                 <b-form-select 
                  size="sm"
                  :options="valPolizas" 
                  v-model="datosFormulario.ccpoliza">
                </b-form-select>
              </b-col>
             </b-row>
          </div>
          <div slot="footer">
            <div class="form-actions">
              <el-row>
                <el-col>
                  <b-button size="sm" v-if="allPoliza" variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                  <b-button size="sm" variant="primary" @click="Limpiar" style="margin-left: 10px;"><i class="fa fa-eraser"></i> Limpiar</b-button>
                </el-col> 
              </el-row>                
            </div>
          </div>         
        </b-card>
         
        <!-- Detalle de la consulta -->
        <b-card v-if="consulta === true">
          <div>
            <b-tabs content-class="mt-3"  lazy v-model="tabIndex" >
              <b-tab title="Registro de Correspondencia" active @click="actboton = false, actboton_lrp = false">
          
                <b-row>
                  <b-col lg="6">
                    <b-button size="sm" v-if="this.hasPoliza" variant="primary" @click="nuevaCorrespon" >Agregar Correspondencia</b-button>        
                  </b-col> 

                  <b-col lg="6">
                    <b-form-group label label-for="filtroProceso">
                      <b-form-input  size="sm"
                        id="filtroProceso"
                        type="text"
                        placeholder="Filtrar"
                        v-model="filters[0].value"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="12">
                    <div ref="refTable">
                    <data-tables ref="refTable1"
                      :data="data1"
                      name="table"
                      class="table-responsive"
                      :current-page.sync="pagina"
                      :table-props="tableProps2"
                      :filters="filters"
                      :page-size="10"
                      :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                      layout="table"
                    >
                      <el-table-column
                        v-for="title in titles"
                        :min-width="title.minwidth" 
                        :prop="title.prop"
                        :label='title.label'
                        :key="title.label"
                        :align="title.align"
                        sortable="custom"
                        :formatter="formatter"
                        name="table"
                        class="table-responsive"
                      ></el-table-column>
                      <el-table-column label="" min-width="290px" align="center">
                          <template slot-scope="scope">
                              <el-button
                                    size="mini"
                                    type="primary"
                                    @click="button.handler"
                                    v-for="button in customButtonsForRow(scope.row)"
                                    :key="button.id"
                                  >
                                    {{ button.name }}
                              </el-button>
                          </template>
                      </el-table-column>
                    </data-tables>
                    </div>
                  </b-col>
                </b-row>
        
              </b-tab>
                 
              <b-tab  title="Contishare" v-if="datosFormulario.poliza > 0" @click="actboton = false, actboton_lrp = false">
                <b-row>   
                   <!-- <el-table-column label="" min-width="800px" align="center">
                   </el-table-column> -->
                  <b-col lg="10">
                    <div ref="refTable">
                      <data-tables
                        ref="refTable3"
                        :data="dataFiniquitos"
                        name="table"
                        class="table-responsive"
                        :current-page.sync="pagina"
                        :table-props="tableProps2"
                        :page-size="10"
                        :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                        layout="table"
                        @select="handleSelectionChange2"
                        @select-all="selectAll"                  
                      >
                      <el-table-column
                        v-for="title in titlesFiniquitos"
                        :min-width="title.minwidth"
                        :prop="title.prop"
                        :label="title.label"
                        :key="title.label"
                        :align="title.align"
                          
                        :formatter="formatter"
                        name="table"
                        class="table-responsive"
                      ></el-table-column>
                        
                      <el-table-column label="" min-width="100px" align="center">
                        <template slot-scope="scope">
                          <el-button type="text" @click="verFiniquito(scope.row.LINK)">Ver</el-button>   
                        </template>
                      </el-table-column>

                      <!-- <el-table-column type="selection" width="35" reserve-selection>
                      </el-table-column> -->

                      <el-table-column label="" min-width="10px" align="center">
                      </el-table-column>

                    </data-tables>
              </div>
            </b-col>
          </b-row>   

          </b-tab>
              <b-tab  title="Producción" v-if="datosFormulario.poliza > 0" @click="actboton = false, actboton_lrp = false">
                <Polizas ref="tabPolizas"  
                        :poliza="datosFormulario.poliza"
                        :cod_asegurado="datosFormulario.cccodigo" 
                        :participacion="datosFormulario.participacion"
                        :fedesde="this.convierteFecha(datosFormulario.feinicio)"
                        :fehasta="this.convierteFecha(datosFormulario.fefin)"
                        >
                </Polizas>
              </b-tab>
            </b-tabs>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      size="lg"
      scrollable
      hide-footer
      :title="modaltitle"
      cancel-title="Cancelar"
      v-model="modalPolizas"
      @cancel="modalPolizas = false"
    >

    <b-row>
        <b-col sm="2">  
                <b-form-group
                  label="Póliza"
                  label-for="polizaB"
                >
                <b-form-input 
                  size="sm"
                  id="polizaB"
                  type="text"
                  placeholder=""
                  v-model="datosBusqueda.polizaB"
                  v-on:keyup="enter">
                </b-form-input>
                
                </b-form-group>
        </b-col>
        <b-col sm="4">
              <b-form-group
                  label="Nombre Afianzado"
                  label-for="nomafianzadoB"
                >
                <b-form-input
                  size="sm"
                  id="nomafianzadoB"
                  type="text"
                  placeholder=""
                  v-model="datosBusqueda.nomafianzadoB"
                  v-on:keyup="enter">
                </b-form-input>
              </b-form-group>
        </b-col>
        <b-col sm="4">
              <b-form-group
                  label="Nombre Beneficiario"
                  label-for="nombeneficiarioB"
                >
                <b-form-input
                  size="sm"
                  id="nombeneficiarioB"
                  type="text"
                  placeholder=""
                  v-model="datosBusqueda.nombeneficiarioB"
                  v-on:keyup="enter">
                </b-form-input>
              </b-form-group>
        </b-col>
        <b-col sm="2">
             <b-form-group
                  label="asdf"
                  label-class="label-blanco"
                  label-for="buscar"
                  color="red"
                >
                <b-button  size="sm" id="buscar" variant="primary" @click="buscarPoliza"><i class="fa fa-search"></i> Buscar</b-button>
              </b-form-group>
                
            </b-col>
    </b-row>
    <br>

<b-card>
    <b-row>
       <b-col lg="12">             
        <div ref="refTable3">
          <data-tables ref="refTable3"
            :data="data2"
            name="table2"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps2"
            :filters="filtersId"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table">
            <el-table-column
              v-for="title in titles2"
              :min-width="title.minwidth" 
              :prop="title.prop"
              :label='title.label'
              :key="title.label"
              :align="title.align"
              sortable="custom"
              :formatter="formatter"
              name="table"
              class="table-responsive">
                <template slot-scope="scope">
                    <div v-if="title.prop == 'poliza'">  
                        <b-link type="text" v-if="scope.row.poliza > 0" @click="selecciona_poliza(scope.row.poliza, scope.row.codigo, scope.row.rut, scope.row.nombre)" >{{scope.row.poliza}}</b-link>
                                         <p v-else >{{scope.row.poliza}}</p> 
                                         
                    </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
                  </template>
              
            </el-table-column>

          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-card>
    </b-modal>

    <b-modal
      size="lg"
      scrollable
      hide-footer
      :title="modaltitle"
      cancel-title="Cancelar"
      v-model="modalSiniestros"
      @cancel="modalSiniestros = false"
    >

    <b-row>
      <b-col lg="12">             
        <div ref="refTable3">
          <data-tables ref="refTable3"
            :data="data3"
            name="table2"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps2"
            :filters="filtersId"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table">
            <el-table-column
              v-for="title in titles3"
              :min-width="title.minwidth" 
              :prop="title.prop"
              :label='title.label'
              :key="title.label"
              :align="title.align"
              sortable="custom"
              :formatter="formatter"
              name="table"
              class="table-responsive">
                <!-- <template slot-scope="scope">
                    <div v-if="title.prop == 'poliza'">  
                        <b-link type="text" v-if="scope.row.poliza > 0" @click="selecciona_poliza(scope.row.poliza, scope.row.codigo, scope.row.rut, scope.row.nombre)" >{{scope.row.poliza}}</b-link>
                                         <p v-else >{{scope.row.poliza}}</p> 
                                         
                    </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
                  </template> -->
              
            </el-table-column>
            <el-table-column label="Contishare" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" @click="DocContishare(scope.row.siniestro, scope.row)">Ver</el-button>   
                  </template>
            </el-table-column>
            <el-table-column label="Detalle Siniestro" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" @click="VerSiniestro(scope.row)">Ver</el-button>   
                  </template> 
            </el-table-column>

          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>

 <!-- Detalle Documentación de Contishare -->
    <b-modal
      hide-footer
      size="lg"
      title="Documentación de Contishare"
      cancel-title="Cerrar"
      ok-title="Guardar"
      class="modal-success"
      v-model="modalDocContishare"
      @ok="guardarLinkContishare();"
      @cancel="modalDocContishare = false"
    >
      <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable3"
                  :data="dataDocContishare"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @select="handleSelectionChange2"
                  @select-all="selectAll"                  
                >
                  <el-table-column
                    v-for="title in titlesDocContishare"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                  
                  <el-table-column label="" min-width="100px" align="center">
                  <template slot-scope="scope">
                      <el-button type="text" @click="verDocumento(scope.row.LINK)">Ver</el-button>   
                  </template>
                  </el-table-column>

                  <!-- <el-table-column type="selection" width="35" reserve-selection>
                  </el-table-column>


                  <el-table-column label="" min-width="10px" align="center">
                  </el-table-column> -->

                </data-tables>
              </div>
            </b-col>
          </b-row>
    </b-modal>


    <b-modal
      title="Nueva Correspondencia"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      size="lg"
      v-model="modalNuevo"
      @ok="saveRow();"
      @cancel="modalNuevo = false"
    >
    
      <b-row class="my-1">
        <b-col sm="3">
          <label>Póliza</label>
        </b-col>
        <b-col sm="2">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  size="sm" 
                  v-model="datosFormularioModal.poliza">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col sm="3">
          <label for="input-small">Mto. Asegurado</label>
        </b-col>
        <b-col sm="1">
          <b-form-input 
            id="input-small" 
            size="sm" 
            type="text"
            disabled
            v-model="datosFormulario.monedapol">
            </b-form-input>
          </b-col>
          <b-col sm="3">
            <b-form-input 
              id="input-small" 
              size="sm" 
              type="text"
              disabled
              v-model="datosFormulario.mtoaseg">
          </b-form-input>
        </b-col>
      </b-row>        
      <b-row class="my-1">
        <b-col sm="3">
          <label>Monto Denunciado</label>
        </b-col>
         <b-col sm="1">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  size="sm" 
                  v-model="datosFormularioModal.monedapol">
              </b-form-input> 
          </b-form-group>
        </b-col>
        <b-col sm="3">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  size="sm" 
                  v-model="datosFormularioModal.mtodenun">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="3">
          <label>Fecha Denuncio</label>
        </b-col>
        <b-col sm ="4">
          <b-form-datepicker 
            id="idfedenuncio" 
            v-model="datosFormularioModal.fdenun" 
            :default-value="this.datosFormularioModal.fdenun"
            size="sm" 
            :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
            locale="ES"
            >
          </b-form-datepicker>
          </b-col>
        </b-row>   
         <!-- <b-col sm="6">
              <b-input-group size="sm">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-calendar"></i>
                    </span>
                  </div>
                  <datepicker 
                    :language="es"
                    format="dd/MM/yyyy"
                    :use-utc="true"
                    input-class="form-control"
                    v-model="datosFormularioModal.fdenun"
                    :disabled="campoBloqueado('fdenun', 'datosFormularioModal')"
                  ></datepicker>

                  <span class="error-validacion-campo">{{ mensajeValidacionCampo.fdenun }}</span>
              </b-input-group>
          </b-col> -->
      
      
      <b-row class="my-1">
        <b-col sm="3">
          <label>Ejecutivo Siniestros</label>
        </b-col>
        <b-col sm="4">
          <b-form-group>
             <b-form-select
                  :options="valEjecutivos"
                  v-model="datosFormularioModal.ejesin"
                  size="sm" 
                  :disabled="campoBloqueado('ejesin', 'datosFormularioModal')"
                ></b-form-select> 
                 <span class="error-validacion-campo">
                  {{ mensajeValidacionCampo.ejesin }}
                </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col sm="3">
          <label>Asistente Siniestros</label>
        </b-col>
        <b-col sm="4">
         <b-form-group>
             <b-form-select
                  :options="valAsistentes"
                  v-model="datosFormularioModal.asisin"
                  size="sm" 
                  :disabled="campoBloqueado('asisin', 'datosFormularioModal')"
                ></b-form-select> 
                 <span class="error-validacion-campo">
                  {{ mensajeValidacionCampo.asisin }}
                </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col sm="3">
          <label>Observación</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-textarea
                id="textarea"
                v-model="datosFormularioModal.observacion"
                placeholder="Observaciones..."
                rows="2"
                max-rows="2"
                >
              </b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

    </b-modal>

    <b-modal
      title="Modificación Correspondencia"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      size="lg"
      v-model="modalModificar"
      @ok="saveRow()"
      @cancel="modalModificar = false"
    >
    
      <b-row class="my-1">
        <b-col sm="3">
          <label>Póliza</label>
        </b-col>
        <b-col sm="2">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.poliza">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="3">
          <label for="input-small">Monto Asegurado</label>
        </b-col>
        <b-col sm="2">
          <b-form-input 
            id="input-small" 
            type="text"
            disabled
            v-model="datosFormulario.monedapolmd">
            </b-form-input>
          </b-col>
          <b-col sm="3">
            <b-form-input 
              id="input-small" 
              type="text"
              disabled
              v-model="datosFormulario.mtoasegmd">
          </b-form-input>
        </b-col>
      </b-row>        

      <b-row class="my-1">
        <b-col sm="3">
          <label>Monto Denunciado</label>
        </b-col>
         <b-col sm="2">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.monedapol">
              </b-form-input> 
          </b-form-group>
        </b-col>
        <b-col sm="3">
          <b-form-group>
              <b-form-input 
                  type="number" 
                  v-model="datosFormularioModal.mtodenun">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col sm="3">
          <label>Fecha Denuncio</label>
        </b-col>
         <b-col sm="6">
              <b-input-group>
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-calendar"></i>
                    </span>
                  </div>
                  <datepicker 
                    :language="es"
                    format="dd/MM/yyyy"
                    :use-utc="true"
                    input-class="form-control"
                    v-model="datosFormularioModal.fdenun"
                    :disabled="campoBloqueado('fdenun', 'datosFormularioModal')"
                  ></datepicker>
              </b-input-group>
          </b-col>
      </b-row> 
      <b-row>. </b-row>   
      <b-row class="my-1">
        <b-col sm="3">
          <label>Ejecutivo Siniestros</label>
        </b-col>
        <b-col sm="4">
          <b-form-group>
             <b-form-select
                  :options="valEjecutivos"
                  v-model="datosFormularioModal.ejesin"
                  :disabled="campoBloqueado('ejesin', 'datosFormularioModal')"
                ></b-form-select> 
                 
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col sm="3">
          <label>Asistente Siniestros</label>
        </b-col>
        <b-col sm="4">
         <b-form-group>
             <b-form-select
                  :options="valAsistentes"
                  v-model="datosFormularioModal.asisin"
                  :disabled="campoBloqueado('asisin', 'datosFormularioModal')"
                ></b-form-select> 
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col sm="3">
          <label>Observación</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-textarea
                id="textarea"
                v-model="datosFormularioModal.observacion"
                placeholder="Observaciones..."
                rows="2"
                max-rows="2"
                >
              </b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    
    </b-modal>

            <!-- Crear Actividad -->
        <b-modal
            size="lg"
            ok-only
            
            title="Crear Actividad"
            cancel-title="Cancelar"
            ok-title="Cerrar"
            no-close-on-backdrop
            no-close-on-esc
            class="modal-success"
            v-model="modalAccionCompletar"
            @ok="modalAccionCompletar = false"
            @cancel="modalAccionCompletar = false"
            >
            <b-card>
                <b-row size="sm">
                <b-col sm="1"> 
                    <label >Tarea: </label>
                </b-col>
                <b-col sm="5"> 
                    <b-form-select v-model="datosFormulario.tarea" :options="lovTarea" size="sm" @change="obtActividad()"></b-form-select>
                </b-col>
                <b-col sm="3"> 
                    <label >Fecha de inicio: </label>
                </b-col>
                <b-col sm="3"> 
                    <b-form-datepicker 
                        id="example-datepicker" 
                        v-model="datosFormulario.feinicio" 
                        :default-value="this.datosFormulario.feinicio"
                        size="sm" 
                        :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                        locale="ES"
                        >
                    </b-form-datepicker> 
                </b-col>
            </b-row>
            <b-row class="my-1" size="sm">
                <b-col sm="1"> 
                    <label >Actividad: </label>
                </b-col>
                <b-col sm="5"> 
                    <b-form-select v-model="datosFormulario.actividad" :options="lovActividad" size="sm" @change="obtResultado()"></b-form-select>    
                </b-col>
                <b-col sm="3"> 
                    <label >Fecha de vencimiento: </label>
                </b-col>
                <b-col sm="3">
                    <b-form-datepicker 
                        id="example-datepicker" 
                        v-model="datosFormulario.fevencimiento" 
                        :default-value="datosFormulario.fevencimiento"
                        size="sm" 
                        :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                        locale="ES"
                        >
                    </b-form-datepicker> 
                </b-col>
            </b-row>
            <b-row class="my-1" size="sm">
                <b-col sm="1"> 
                    <label >Asistente: </label>
                </b-col>
                <b-col sm="5"> 
                    <b-form-select v-model="datosFormulario.asistente" :options="lovAsistente" size="sm" ></b-form-select>
                </b-col>
                <b-col sm="3">
                    <label >Fecha de término: </label>
                </b-col>
                <b-col sm="3">
                    <b-form-datepicker 
                        id="example-datepicker" 
                        v-model="datosFormulario.fetermino" 
                        size="sm" 
                        :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                        locale="ES"
                        disabled>
                    </b-form-datepicker> 
                    
                </b-col>

            </b-row>
            <b-row class="my-1" size="sm">
                <b-col sm="1"> 
                    <label >Resultado: </label>
                </b-col>
                <b-col sm="2">
                    <b-form-select v-model="datosFormulario.resultado" :options="lovResultado" size="sm" disabled></b-form-select>
                </b-col>
                <b-col sm="1"> 
                    <label >Usuario: </label>
                </b-col>
                <b-col sm="2"> 
                    <b-form-input size="sm" type="text" v-model="datosFormulario.usuario" disabled> </b-form-input> 
                </b-col>
                <b-col sm="3"> 
                    <label >Póliza: </label>
                </b-col>
                <b-col sm="3"> 
                    <b-form-input size="sm" type="text" v-model="datosFormulario.poliza" disabled> </b-form-input> 
                </b-col>
            </b-row>
            <b-row class="my-1" size="sm">
                <b-col sm="9"> </b-col>
                <b-col sm="3"> 
                    <b-form-checkbox
                        id="checkbox-1"
                        v-model="datosFormulario.prioridad"
                        name="checkbox-1"
                        value="1"
                        unchecked-value="0"
                        >
                        Prioridad
                    </b-form-checkbox> 
                </b-col>
            </b-row>
            <b-row class="my-1" size="sm">
                <b-col sm="12"> 
                    <b-form-textarea
                        id="textarea"
                        v-model="datosFormulario.comentarios"
                        placeholder="Comentarios..."
                        rows="3"
                        max-rows="3">
                    </b-form-textarea>
                </b-col>    
            </b-row>    
        </b-card>   
            <template #modal-footer>
                <b-col  sm="9" class="float-left" >
                    <b-button  @click="modalAccionCompletar=false" >
                        Cancelar
                    </b-button>
                </b-col>
                    
                <b-col sm="3" class="float-right"   >
                    <!-- <b-button size="md" variant="outline-secondary" @click="reasignar()">
                        Reasignar
                    </b-button> -->
                    
                    <b-button class="float-right el-button" size="sm"  @click="insertar_tarea">
                        Aceptar
                    </b-button>
                </b-col>         
            </template>
            
        </b-modal>

    <b-alert 
      dismissible
      :variant="variant"
      v-model="showAlert"
      >
      <p>{{ mensaje }} </p>
      
    </b-alert>

  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiRegCorrespon from "@/components/services/apiRegCorrespon";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";
//  import Persona from './persona.vue';
 import Polizas from './polizas.vue';

export default {
  name: "BaseAsegurado",
  mixins: [tablasMixin, globalesMixin, utilesMixin],

  props: {

    corrPoliza: Number,
  },

  components: {
    cSwitch
  },
  data: function() {
    return {
      datapoliza:[],
      data: [],
      data1: [],
      data2: [],
      data3: [],
      dataDocContishare: [],
      dataFiniquitos: [],
      valEjecutivos: [],
      valAsistentes: [],
      
      lovTarea: [],
      lovActividad: [],
      lovAsistente: [],
      lovResultado: [],
     
      modalNombre: false,
      modalPolizas: false,
      modalSiniestros: false,
      modalNuevo : false,
      modalModificar : false,
      modalDocContishare: false,
      modalAccionCompletar: false,
      hasCorredor: false,
      allPoliza: false,
      hasSiniestro: false,
      agregar: false,
      exportar: false,
      tieneAcceso: true,
      consulta: false,
      actboton: false,
      actboton_lrp: false,
      tabIndex: 0,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      
      titles: [   
        {
          prop: "correlativo",
          label: "Correlativo",
          align: "right",
          minwidth:'80'
        },
        {
          prop: "poliza",
          label: "Póliza",
          align: "right",
          minwidth:'100'
        },
        {
          prop: "producto",
          label: "Producto",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "nombrebenef",
          label: "Beneficiario",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "nombreafian",
          label: "Afianzado",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "moneda",
          label: "Moneda",
          align: "left",
          minwidth:'60'
        },
        {
          prop: "mtodenun",
          label: "Mto. Denunciado",
          align: "right",
          minwidth:'130'
        },
        {
          prop: "fdenun",
          label: "Fe. Denuncio",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "dig",
          label: "Dig.",
          align: "left",
          minwidth:'50'
        },
        {
          prop: "ejesin",
          label: "Eje. Sin.",
          align: "left",
          minwidth:'60'
        },
        {
          prop: "asisin",
          label: "Asis. Sin.",
          align: "left",
          minwidth:'70'
        },
        {
          prop: "ejecom",
          label: "Eje. Com.",
          align: "left",
          minwidth:'60'
        },
        {
          prop: "asiscom",
          label: "Asis. Com.",
          align: "left",
          minwidth:'70'
        },
        {
          prop: "observacion",
          label: "Observación",
          align: "left",
          minwidth:'200'
         }
      ],

      titles2: [
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "codigo",
          label: "Cod. Afianzado",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "rut",
          label: "Rut Afianzado",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "nombre",
          label: "Nombre Afianzado",
          align: "left",
          minwidth:'150'
        },
         {
          prop: "codbeneficiario",
          label: "Cod. Beneficiario",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "rutbeneficiario",
          label: "Rut Beneficiario",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "nombrebeneficiario",
          label: "Nombre Beneficiario",
          align: "left",
          minwidth:'150'
        }              
      ],

      titles3: [
        {
          prop: "siniestro",
          label: "Siniestro",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "fdenun",
          label: "Fecha Denuncio",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "estado",
          label: "Estado",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "festado",
          label: "Fecha Estado",
          align: "left",
          minwidth:'150'
        }            
      ],

       titlesDocContishare: [
        {
          prop: "CSHTITULO",
          label: "Categoría - Nombre del Documento",
          align: "left",
          minwidth: "250",
        },      
        {
          prop: "FECHA",
          label: "Fecha",
          align: "center",
          minwidth: "120",
        },  
       ],   

      titlesFiniquitos: [
        {
          prop: "CSHTITULO",
          label: "Nombre Finiquito",
          align: "left",
          minwidth: "250",
        },        
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],
      
      filtersNombre: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      filtersId: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ], 

      datosFormularioModal: {
          correlativo:"",
          poliza:"",
          monedapol:"",
          mtodenun:"",
          dig:"",
          fdenun:"",
          ejesin:"",
          asisin:"",
          observacion:""  
      },

      limpiar: false,
      modaltitle: "",
      mostrarFechas: true,
      showAlert: false,
      variant: "",
      mensaje: "",
      dismissSecs: 5,
      dismissCountDown: 0,
      
      datosFormulario: {
          producto:"",
          vigdesde:"",
          vighasta:"",
          cobertura:"",
          cccodigo: "",
          ccnombre: "",
          ccrut: "",
          codaseg: "",
          rutaseg: "",
          nombreaseg: "",
          codbenef: "",
          rutbenef: "",
          nombrebenef: "",
          codcorr: "",
          rutcorr: "",
          nombrecorr: "",
          monedapol: "",
          mtoaseg: "",
          condicion: "",
          ejecom: "",
          asiscom: "",
          nombre: "",
          rut: "",
          poliza: "",
          codigo: "",
          participacion: 0,
          feinicio: "",
          fefin: "",
          tarea:"",
          actividad:"",
          asistente:"",
          resultado:"",
          usuario:"",
          feinicio:"",
          fevencimiento:"",
          fetermino:"",
          poliza:"",
          prioridad:"",
          comentarios:"",
          codejecutivo:"",
          codbeneficiario:"",
          idnacion:"",
          nombre:"",
          codejecutivo: "",
          codbeneficiario: "",
          idnacion: "",
          nombre: "",
          mtoasegmd: "",
          monedapolmd: ""
      },

      datosBusqueda: {
        polizaB: '',
        nomafianzadoB: '',
        nombeneficiarioB: ''
      },

      value: null,
      mensajeValidacionCampo: {},
      multipleSelection: [],
      
      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        // rowKey: "id"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect,
    Polizas
  },
  methods:{


    

    setfecha(){
      this.datosFormulario.feinicio = this.datosFormulario.ferpt;
    },

    enter: function(e) {
      e.preventDefault();
      if (e.keyCode === 13) {
        this.buscarPoliza();
      }
    },

    verFiniquito(link) {
      window.open(link, '_blank');
    },
    
    customButtonsForRow(row) {
      
          var botones = new Array();
          
          var obj = new Object();
          obj.tooltip = "Modificar";
          obj.id = 1;
          obj.name="Modificar";
          obj.icon = "fa fa-pencil-square-o";
          obj.type = "success";
          obj.handler= _ => {
              this.$session.start();
              this.recuperar_corresp(row);
          }
          botones.push(obj);

          var obj2 = new Object();
          obj2.tooltip = "Completar";
          obj2.id = 2;
          obj2.name="Completar";
          obj2.icon = "fa fa-eraser";
          obj2.type = "success";
          obj2.handler= _ => {
              this.$session.start();
              this.crearTarea(row);
          }
          botones.push(obj2);

          var obj3 = new Object();
          obj3.tooltip = "Siniestrar";
          obj3.id = 3;
          obj3.name="Siniestrar";
          obj3.icon = "fa fa-eraser";
          obj3.type = "success";
          obj3.handler= _ => {
              this.$session.start();
              this.siniestrar(row);
          }
          botones.push(obj3);
          
          return botones;

    },

    siniestrar(row){
        console.log(row);
 
        this.$router.push({ path: 'CrearSiniestro', query: { deDonde: 'siniestrar', 
                                                             nroCorrespondencia: row.correlativo, 
                                                             nroSiniestro: '', 
                                                             nroPoliza: row.poliza, 
                                                             ejecutivo: row.ejesin, 
                                                             asistente: row.asisin, 
                                                             mtoDenunciado: row.mtodenun, 
                                                             observacion: row.observacion,
                                                             sgcfedenuncio: row.sgcfedenuncio }});
    },
 
    VerSiniestro(row){
         console.log(row.siniestro);
 
        this.$router.push({ path: 'CrearSiniestro', query: { deDonde: 'VerSiniestro' , nroCorrespondencia: undefined, nroSiniestro: row.siniestro, nroPoliza: '', ejecutivo: undefined, asistente: undefined, mtoDenunciado: undefined }});
    },
 
    selecciona_poliza(p_poliza, p_codigo, p_rut, p_nombre){
      // this.datosFormulario.poliza = p_poliza;
      // this.datosFormulario.cccodigo = p_codigo;
      // this.datosFormulario.ccrut = p_rut;
      // this.datosFormulario.ccnombre = p_nombre
      this.modalNombre = false;
      this.modalPolizas = false;
      this.tieneAcceso=false; 
      this.consulta=true;
      this.hasPoliza = true;
      this.allPoliza = false;
      this.hasSiniestro = false;

      return apiRegCorrespon
        .recuperar_polcorsin(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          p_poliza
          )  
          .then(response => {
            response.data = this.keysMinuscula(response.data);
            this.data1 = response.data.res1;
            this.data3 = response.data.res2;
            var datapoliza  = response.data.res;

             if (response.data.res2.length > 0){
                this.hasSiniestro = true; 
              }
              else {this.hasSiniestro = false};

              this.finiquitos(p_poliza);
              this.datosFormulario.poliza = p_poliza;

            for (var i = 0; i < datapoliza.length; i++) {
                this.datosFormulario.producto = datapoliza[i]["producto"];
                this.datosFormulario.vigdesde = datapoliza[i]["vigdesde"];
                this.datosFormulario.vighasta = datapoliza[i]["vighasta"];
                this.datosFormulario.cobertura = datapoliza[i]["cobertura"];
                this.datosFormulario.codaseg = datapoliza[i]["codaseg"];
                this.datosFormulario.rutaseg = datapoliza[i]["rutaseg"];
                this.datosFormulario.nombreaseg = datapoliza[i]["nombreaseg"];
                this.datosFormulario.codbenef = datapoliza[i]["codbenef"];
                this.datosFormulario.rutbenef = datapoliza[i]["rutbenef"];
                this.datosFormulario.nombrebenef = datapoliza[i]["nombrebenef"];
                this.datosFormulario.codcorr = datapoliza[i]["codcorr"];
                this.datosFormulario.rutcorr = datapoliza[i]["rutcorr"];
                this.datosFormulario.nombrecorr = datapoliza[i]["nombrecorr"];
                this.datosFormulario.monedapol = datapoliza[i]["monedapol"];
                this.datosFormulario.mtoaseg = datapoliza[i]["mtoaseg"];
                this.datosFormulario.condicion = datapoliza[i]["condicion"];
                this.datosFormulario.ejecom = datapoliza[i]["ejecom"];
                this.datosFormulario.asiscom = datapoliza[i]["asiscom"];

                this.datosFormulario.cccodigo = datapoliza[i]["codafian"];
                this.datosFormulario.ccrut = datapoliza[i]["rutafian"];
                this.datosFormulario.ccnombre = datapoliza[i]["nombreafian"];
            }

          })
          .catch(error => {
            this.crearNotificacion("Error de sistema", error, "error");
            this.$Progress.finish();
          });
    }, 
    
// finiquitos(poliza, row){
   finiquitos(poliza){
      this.$Progress.start();
     // console.log(poliza);
      return apiRegCorrespon
        .finiquitos(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          poliza
        )
        .then((response) => {
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          this.dataFiniquitos = response.data.res1;
          // this.datalink = row;
          this.modalFiniquitos = true;
           
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.refTable.$children[0].toggleRowSelection(row);
        });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    buscar() {
      this.$Progress.start();
      this.tabIndex = 0;
      this.consulta=true;
      this.agregar = false;

      var p_poliza = this.datosFormulario.poliza == '' ? '0': this.datosFormulario.poliza;
      
      var p_email = this.$session.get("mail");
      var p_usuario = this.$session.get("usuarioInterno");

      return apiRegCorrespon
        .buscar(p_email, p_usuario, p_poliza
        )
        .then(response => {
          response.data = this.keysMinuscula(response.data);
          this.data1  = response.data.res1;
          this.$Progress.finish();
          
           if (this.data1 != null){
             this.agregar = true;
           } else {
             this.agregar = false;
           }
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscarPoliza (){
      this.$Progress.start();
      return apiRegCorrespon
        .buscarPoliza(
          this.$session.get("mail"),
          this.datosBusqueda.polizaB, 
          this.datosBusqueda.nomafianzadoB,
          this.datosBusqueda.nombeneficiarioB
        )
        .then(response => {
         response.data = this.keysMinuscula(response.data);
          this.data2  = response.data.res;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          this.datosBusqueda.polizaB = "";
          this.datosBusqueda.nomafianzadoB = "";
          this.datosBusqueda.nombeneficiarioB = "";
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

      handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    handleSelectionChange2(selection, row) {

      this.nomdoccontish = row.CSHTITULO;
      this.linkdoccontish = row.LINK;

      if (selection.length > 1 ) {
            this.crearNotificacion("Error de sistema", "Solo se puede seleccionar un solo registro", "error");
            this.$refs.refTable3.$children[0].toggleRowSelection(row, false);
            return;
           }
    },

    selectAll(rows){
      this.$refs.refTable3.$children[0].clearSelection();
      return;
    },

    DocContishare(siniestro, row){
      this.$Progress.start();
      return apiRegCorrespon
        .DocContishare(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          siniestro
        )
        .then((response) => {
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          this.dataDocContishare = response.data.res1;
          this.datalink = row;
          this.modalDocContishare = true;
          
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

verDocumento(link) {
      window.open(link, '_blank');
    },

    guardarLinkContishare(){
      apiRegCorrespon
          .guardar_link_contishare(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datalink.Siniestro,
            this.linkdoccontish,
            this.nomdoccontish
          )
          .then(response => {
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Link Contishare",
                "Link de Contishare guardada con éxito.",
                "success"
              ); 
            }
            else{
              this.crearNotificacion("Error de sistema", response.data.festado.resultado.mensaje, "error");
            }
            
            this.modalObservacion = false;
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    }, 

    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    formatNumber(n) {
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },

    pre_insertar_limpiar(){
      this.pre_insertar();
    },

    Limpiar() {
      // this.datosFormulario.poliza = "";
      
      this.tabIndex = 0;
      this.datosBusqueda.polizaB = "";
      this.buscarPoliza();
      this.selecciona_poliza(null, null, null, null);
      this.pre_insertar();
    },

    pre_insertar() {
      this.$Progress.start(); 
      this.hasPoliza = false;
      this.allPoliza = true;
      this.hasSiniestro = false;
    
      return apiRegCorrespon
        .pre_insertar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          
          response.data = this.keysMinuscula(response.data);
         
          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's' && this.limpiar == false) {
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          var lista_data = response.data.res;
          for (var i = 0; i < lista_data.length; i++) {
            this.datosFormularioModal.fdenun = lista_data[i]["fdenun"];
            this.datosFormularioModal.ejesin = lista_data[i]["ejesin"];
            this.datosFormularioModal.asisin = lista_data[i]["asisin"];
          }

          //Carga lista de ejecutivos
          if (response.data.ejecutivos != undefined){
            var tiposEjecutivos = new Array();
            var lista_tipos_ejecutivos = response.data.ejecutivos;
            for(var i = 0; i < lista_tipos_ejecutivos.length; i++){
                var obj = new Object();
                obj.value = lista_tipos_ejecutivos[i]["codigo"];
                obj.text = lista_tipos_ejecutivos[i]["descripcion"];
                tiposEjecutivos.push(obj);
            }
            this.valEjecutivos = tiposEjecutivos;
          }

          //Carga lista de asistentes
          if (response.data.asistentes != undefined){
            var tiposAsistentes = new Array();
            var lista_tipos_asistentes = response.data.asistentes;
            for(var i = 0; i < lista_tipos_asistentes.length; i++){
                var obj = new Object();
                obj.value = lista_tipos_asistentes[i]["codigo"];
                obj.text = lista_tipos_asistentes[i]["descripcion"];
                tiposAsistentes.push(obj);
            }
            this.valAsistentes = tiposAsistentes;
          }

          this.datosFormulario.poliza = "";
          this.datosFormulario.producto = "";
          this.datosFormulario.vigdesde = "";
          this.datosFormulario.vighasta = "";
          this.datosFormulario.cobertura = "";
          this.datosFormulario.cccodigo = "";
          this.datosFormulario.ccnombre = "";
          this.datosFormulario.ccrut = "";
          this.datosFormulario.codaseg = "";
          this.datosFormulario.rutaseg = "";
          this.datosFormulario.nombreaseg = "";
          this.datosFormulario.codbenef = "";
          this.datosFormulario.rutbenef = "";
          this.datosFormulario.nombrebenef = "";
          this.datosFormulario.codcorr = "";
          this.datosFormulario.rutcorr = "";
          this.datosFormulario.nombrecorr = "";
          this.datosFormulario.monedapol = "";
          this.datosFormulario.mtoaseg = "";
          this.datosFormulario.condicion = "";
          this.datosFormulario.ejecom = "";
          this.datosFormulario.asiscom = "";

          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    nuevaCorrespon() {
      this.datosFormularioModal.mtodenun = null;
      this.datosFormularioModal.observacion = null;

      this.datosFormularioModal.poliza = this.datosFormulario.poliza;
      this.datosFormularioModal.monedapol = this.datosFormulario.monedapol;
      this.modalNuevo = true;

      return apiRegCorrespon
        .pre_insertar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          
          response.data = this.keysMinuscula(response.data);
         
          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's' && this.limpiar == false) {
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          var lista_data = response.data.res;
          for (var i = 0; i < lista_data.length; i++) {
            this.datosFormularioModal.fdenun = lista_data[i]["fdenun"];
            this.datosFormularioModal.ejesin = lista_data[i]["ejesin"];
            this.datosFormularioModal.asisin = lista_data[i]["asisin"];
          }

          //Carga lista de ejecutivos
          if (response.data.ejecutivos != undefined){
            var tiposEjecutivos = new Array();
            var lista_tipos_ejecutivos = response.data.ejecutivos;
            for(var i = 0; i < lista_tipos_ejecutivos.length; i++){
                var obj = new Object();
                obj.value = lista_tipos_ejecutivos[i]["codigo"];
                obj.text = lista_tipos_ejecutivos[i]["descripcion"];
                tiposEjecutivos.push(obj);
            }
            this.valEjecutivos = tiposEjecutivos;
          }

          //Carga lista de asistentes
          if (response.data.asistentes != undefined){
            var tiposAsistentes = new Array();
            var lista_tipos_asistentes = response.data.asistentes;
            for(var i = 0; i < lista_tipos_asistentes.length; i++){
                var obj = new Object();
                obj.value = lista_tipos_asistentes[i]["codigo"];
                obj.text = lista_tipos_asistentes[i]["descripcion"];
                tiposAsistentes.push(obj);
            }
            this.valAsistentes = tiposAsistentes;
          }

          

          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });

      // return apiRegCorrespon
      //   .pre_insertar(
      //     this.$session.get("mail"),
      //     this.$session.get("usuarioInterno")
      //   )  
      //   .then(response => {

      //     this.valEjecutivos = this.llenaArrayLista(response.data.ejecutivos, 'codigo', 'descripcion', false);
      //     this.valAsistentes = this.llenaArrayLista(response.data.asistentes, 'codigo', 'descripcion', false);
          
      //   })
      //     .catch((error) => {
      //        this.crearNotificacion("Error de sistema", error, "error");
      //     }); 
    },

    saveRow() { 
      let rows = this.datosFormularioModal;
      var p_poliza = rows.poliza;
      var p_correlativo = rows.correlativo;

      console.log(this.datosFormularioModal.mtodenun);

      if ((parseInt(p_poliza)>0) && (this.modalModificar)){
        //Modificar



        return apiRegCorrespon
          .modificar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            p_correlativo,
            this.datosFormularioModal.mtodenun,
            this.datosFormularioModal.fdenun,
            this.datosFormularioModal.ejesin,
            this.datosFormularioModal.asisin,
            this.datosFormularioModal.observacion
          )
          .then((response) => {
            
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Modificar",
                "Se ha modificado el registro de correspondencia.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
            // this.datosFormularioModal.mtodenun ="";
            // this.datosFormularioModal.observacion ="";
          })
          .catch((error) => {
             this.crearNotificacion("Error de sistema", error, "error");
          });        
      }else{
        return apiRegCorrespon
          .insertar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormularioModal.poliza,
            this.datosFormulario.monedapol,
            this.datosFormularioModal.mtodenun,
				    this.datosFormularioModal.fdenun,
				    this.datosFormularioModal.ejesin,
				    this.datosFormularioModal.asisin,
            this.datosFormularioModal.observacion
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Insertar",
                "Se ha registrado la nueva correspondencia.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
             this.buscar();
            //  this.datosFormularioModal.mtodenun ="";
            //  this.datosFormularioModal.observacion ="";
             }
          )
          .catch((error) => {
             this.crearNotificacion("Error de sistema", error, "error");
          });
    }
    },

    recuperar_corresp: function( row ) {
      this.$Progress.start(); 

      return apiRegCorrespon
        .recuperar_corresp(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          row.correlativo
        )  
        .then(response => {
          
          if (response.data != undefined){
            response.data = this.keysMinuscula(response.data);
            var DatoCorresp = response.data.res[0];
              this.datosFormularioModal.correlativo = DatoCorresp.correlativo;
              this.datosFormularioModal.poliza = DatoCorresp.poliza;
              // this.datosFormularioModal. = DatoCorresp.poliza;
              this.datosFormulario.monedapolmd = DatoCorresp.monedapol;
              this.datosFormulario.mtoasegmd = DatoCorresp.mtoaseg;
              this.datosFormularioModal.monedapol = DatoCorresp.monedapol;
              this.datosFormularioModal.mtodenun = DatoCorresp.mtodenun;
              this.datosFormularioModal.dig = DatoCorresp.dig;
              this.datosFormularioModal.fdenun = DatoCorresp.fdenun;
              this.datosFormularioModal.ejesin = DatoCorresp.ejesin;
              this.datosFormularioModal.asisin = DatoCorresp.asisin;
              this.datosFormularioModal.observacion = DatoCorresp.observacion;
              
            }

          this.modalModificar = true;
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    formatNumber:function (num) {
          var comma = num.split(',')[1];
          num = num.split(',')[0];
          console.log("Coma:"+comma);
        if (num == 'Infinity') return '&#x221e;';
        console.log(num);
        num = num.toString().replace(/\$|\,/g, '');
        console.log(num);
        num = num.toString().replace('.', '');
        console.log(num);
        num = num.toString().replace(',', '.');
        console.log(num);
        //if (isNaN(num))       num = "0";
        sign = (num == (num = Math.abs(num)));
        num = Math.floor(num * 100 + 0.50000000001);
        cents = num % 100;
        if (cents < 10)
            cents = "0" + cents;
        num = Math.floor(num / 100).toString();
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3) ; i++)
            num = num.substring(0, num.length - (4 * i + 3)) + '.' + num.substring(num.length - (4 * i + 3));
          var result = '';
          if (comma){
            result = ((sign) ? '' : '-') + num +','+comma;
          } else {
            result = ((sign) ? '' : '-') + num;
          }
        return result;
        },

    formatter(row, column) {

      if ((column.property == "fecha"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else {
        return row[column.property];
      }
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

    // buscar_por_poliza: function(){
      
    //   this.$Progress.start();
    //   var p_poliza = this.datosFormulario.poliza == '' ? '': this.datosFormulario.poliza;
    //   var p_rut = this.datosFormulario.rut == '';

    //   var p_email = this.$session.get("mail");
    //   var p_usuario = this.$session.get("usuarioInterno");
       
    //     if ((p_poliza == '')){
    //        this.datosFormulario.p_poliza ="";
    //       //  this.mensaje= "Ingrese el número de póliza";
    //       //  this.variant="warning";
    //       //  this.showAlert = true;
    //       //  this.$Progress.finish();
    //       //  return false;
    //     }
    //   return apiRegCorrespon
    //     .buscar_por_id(
    //       p_email, p_usuario, p_poliza, p_rut
    //     ).then((response) => {
    //      response.data = this.keysMinuscula(response.data);
    //       this.data2 = response.data.res;
    //       this.modaltitle = "Búsqueda por Póliza",
    //       this.modalPolizas = true;
    //       this.$Progress.finish();
    //     })
    //     .catch((error) => {
    //      this.crearNotificacion("Error de sistema", error, "error");
    //       this.$Progress.finish();
    //     });

    // },

    intersection(o1, o2) {
    return Object.keys(o1).concat(Object.keys(o2)).sort().reduce(function (r, a, i, aa) {
        if (i && aa[i - 1] === a) {
            r.push(o1[a].value);
        }
         return r;
    }, []);
    },

    /* Accion Completar*/
    crearTarea(row){
        console.log(row);
        this.datosFormulario.correspondencia = row.correlativo;
        this.datosFormulario.tarea = null;
        this.datosFormulario.actividad = null;
        this.datosFormulario.asistente = row.asisin;
        this.datosFormulario.resultado = null;
        this.datosFormulario.usuario = null;
        this.datosFormulario.feinicio = null;
        this.datosFormulario.fevencimiento = null;
        this.datosFormulario.fetermino = null;
        this.datosFormulario.poliza = row.poliza;
        this.datosFormulario.prioridad = null;
        this.datosFormulario.comentarios = null;
        this.modalAccionCompletar= true;
        this.pre_InserCompl();

    },



    insertar_tarea() {

        return apiRegCorrespon
            .insertar_tarea(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.datosFormulario.tarea, 
                this.datosFormulario.actividad, 
                this.datosFormulario.asistente, 
                this.datosFormulario.feinicio, 
                this.datosFormulario.fevencimiento, 
                this.datosFormulario.fetermino, 
                this.datosFormulario.resultado, 
                this.datosFormulario.poliza, 
                this.datosFormulario.siniestro,
                this.datosFormulario.correspondencia, 
                this.datosFormulario.prioridad, 
                this.datosFormulario.comentarios
            )
            .then((response) => {
                this.datosFormularioEstado = response.data.festado;
                this.crearNotificacion("Crear Actividad","Actividad Creada.","success");
                this.modalAccionCompletar= false;
                this.buscar()

                
            })
            .catch((error) => {
            this.crearNotificacion("Error de sistema", error, "error");
            });



    },
    
    pre_InserCompl() {
        return apiRegCorrespon
            .pre_InserCompl(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                0,
                0
            )
            .then((response) => {
                response.data = this.keysMinuscula(response.data);
          
                //Bloqueo usuario no valido
                this.datosFormulario.usuario = response.data.args_out.codejecutivo;
                
                this.lovTarea = this.llenaArrayLista(response.data.tareas, 'codigo', 'descripcion', false);
                this.lovAsistente = this.llenaArrayLista(response.data.asistentes, 'codigo', 'descripcion', false);
                this.datosFormulario.tarea = 14;
                this.obtActividad(); 
                
                this.datosFormularioEstado = response.data.festado;
            })
            .catch((error) => {
            this.crearNotificacion("Error de sistema", error, "error");
            });
    },

    obtActividad(){
        return apiRegCorrespon
            .pre_InserCompl(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.datosFormulario.tarea,
                0
            )
            .then((response) => {
                response.data = this.keysMinuscula(response.data);
                this.lovActividad = this.llenaArrayLista(response.data.actividades, 'codigo', 'descripcion', false);

                var lista_actividad = response.data.actividades;
                for(var i = 0; i < lista_actividad.length; i++){
                    this.datosFormulario.actividad =  lista_actividad[i]["activdefault"];
                    
                }
                if (this.datosFormulario.actividad != ''){
                        this.obtResultado();
                    }
            })
            .catch((error) => {
            this.crearNotificacion("Error de sistema", error, "error");
            });
    
    },

    obtResultado(){
        return apiRegCorrespon
            .pre_InserCompl(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.datosFormulario.tarea,
                this.datosFormulario.actividad,
            )
            .then((response) => {
                response.data = this.keysMinuscula(response.data);

                var lista_data = response.data.res;
                for(var i = 0; i < lista_data.length; i++){
                    
                    this.datosFormulario.feinicio = lista_data[i]["feingreso"];
                    this.datosFormulario.fevencimiento = lista_data[i]["fevencimiento"];
                }

                this.lovResultado = this.llenaArrayLista(response.data.resultados, 'codigo', 'descripcion', false);
                
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    obt_datcorrespondencia(){
        
        this.datosBusqueda.dedonde = this.$route.query.deDonde;


        if (this.$route.query.corrPoliza > 0 && this.datosBusqueda.dedonde === 'crearSiniestro'){
        console.log(this.$route.query.corrPoliza, 'desde crear siniestro');
        
        this.selecciona_poliza(this.$route.query.corrPoliza, null,null,null);
        
        
        
        }
        
        
    },
    
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();  
    this.obt_datcorrespondencia();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
    
    data: function() {
      this.$nextTick(function() {
        // this.$refs.refTable1.$children[0].clearSelection();
        var lista = this.data;
        var index = 0;
        for (index = 0; index < lista.length; ++index) {
            // this.toggleSelection([lista[index]]);
        }
      })
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
    color: #fff;
}

.el-button-canc{
    background: #00000088;
    color: #00000088;
}

.label-blanco{
  color: #fff;
}
</style>
